import { VideoCallUser } from '@tabeeb/modules/../users/types'
import {
  getGridVideoContainerById,
  getLargeVideoContainer,
  getVideoContainerById,
} from '@tabeeb/modules/presentation/services/trackService'

const getCanvasSnapshot = (canvas: HTMLCanvasElement, type: string = 'image/png', quality: number = 1) =>
  new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, type, quality)
  })

export const takeUserVideoSnapshot = async (
  userId: number,
  selectedUser: VideoCallUser | null,
  isGridView: boolean = false
): Promise<Blob | null> => {
  let video: HTMLVideoElement | null = null
  if (isGridView) {
    video = getGridVideoContainerById(userId)
  } else if (selectedUser?.id === userId) {
    video = getLargeVideoContainer()
  } else {
    video = getVideoContainerById(userId)
  }

  if (!video) {
    return null
  }

  const canvas = document.createElement('canvas')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  canvas.style.display = 'none'

  const ctx = canvas.getContext('2d')
  ctx?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight)

  return getCanvasSnapshot(canvas, 'image/jpeg', 1.0)
}
